//EliAutoComplete
//  Author:     Pirooze
//  Date:   2019/11/04
jQuery.fn.eliTypeAutoComplete = function (userOptions) {
    var options = {};
    var typeCache = [];
    var typeCacheList = [];
    var timerAutoComplete = null;
    options = {
        input: this,//Input jQuery selector
        minLength: 2,//Mion Length Chars For Ajax Call
        maxItem: 8,//Max Items Call In Popup
        delay: 100,//Delay Of Display And Hide Popup
        display: true, //Visible Popup
        cancelButton: true,//Display Cancel Button
        loadingAnimation: true,//Display Loading Button
        source: null,
        value: '',
        hidden: null,
        sourceUrl: '',
        data: null,
        defaultCulture: 'fa-IR',
        CultureCokkieName: '_cultureSetting',
        firstEmptyDataForLoadAjax: '+++',
        secondEmptyDataForLoadAjax: '***',
        selector: {//Default Class Names
            container: "acs__container",
            result: "autocpmplete__content-wrapper",
            list: "autocpmplete__content",
            group: "autocpmplete__group",
            input: "autocpmplete__input",
            item: "autocpmplete__element",
            itemOption: "autocpmplete__option",
            itemMainOption: "autocpmplete__option_main",
            itemOptionText: "autocpmplete__option_text",
            itemOptionShortDesc: "autocpmplete__option_shortdesc",
            itemOptionLongDesc: "autocpmplete__option_longdesc",
            itemSelectedCls: "autocpmplete__option_selected",
            cancelButton: "autocpmplete__cancel-button",
            loadingButton: "autocpmplete__loading-button",
            disableItem: "autocpmplete__element-disable",
            tagItem: "autocpmplete__element-tag",
            rtlClassForInput: "autocpmpleteInputRtl",
            rtlClassForResult: "autocpmpleteResultRtl"
        }
    };
    var _create = function (userOptions) {
        if ($(options.input).hasClass(options.selector.input))
            return false;
        _setUserOptions(userOptions);
        options.hidden = _getInputHiddenElement();
        $(options.hidden).attr("required", "required");
        _addCancelButtonElement();
        _setDefaultEvenets();
        _setCultureClass();
        _setVisibleCancelButtonElement();
        $(options.input).addClass(options.selector.input);
    };
    var _setCultureClass = function () {
        $(options.input).removeClass(options.selector.rtlClassForInput);
        $(options.input).removeClass(options.selector.rtlClassForInput);
        $(_getInputParentElement()).find("." + options.selector.result).removeClass(options.selector.rtlClassForResult);
        if ($(options.input).val().length == 0) {
            if (getCookie(options.CultureCokkieName) == null || getCookie(options.CultureCokkieName) == options.defaultCulture || getCookie(options.CultureCokkieName) == '') {
                $(options.input).addClass(options.selector.rtlClassForInput);
                $(_getInputParentElement()).find("." + options.selector.result).addClass(options.selector.rtlClassForResult);
            }
        }
        else if (/[^\u0600-\u06FF]/g.test($(options.input).val().substring(0, 5).replace(/[-, ,),(,,]/g, ''))) {
            //En lang
        } else { //if writtent text is Persian
            $(options.input).addClass(options.selector.rtlClassForInput);
            $(_getInputParentElement()).find("." + options.selector.result).addClass(options.selector.rtlClassForResult);
        }
    };
    var _setDefaultEvenets = function () {
        $(options.input).on("keydown", function (e) {
            if (e.keyCode == 9 || e.keyCode == 13) {
                e.stopPropagation();
                e.preventDefault();
                _clearHiddenHelper();
                if ($(_getInputParentElement()).find("." + options.selector.result).is(":visible")) {
                    if ($(_getInputParentElement()).find("." + options.selector.result).find("li").length > 0) {
                        _setValue($(_getInputParentElement()).find("." + options.selector.result).find("." + options.selector.itemSelectedCls).closest("li").attr("data-text"), $(_getInputParentElement()).find("." + options.selector.result).find("li:first-child()").attr("data-val"));
                        _closePopup();
                        setTimeout(function () {
                            var currentTabIndex = parseInt($(options.input).attr("tabindex"));
                            if (currentTabIndex != null && currentTabIndex > 0 && $('[tabindex="' + (currentTabIndex + 1) + '"]') != undefined) {
                                $('[tabindex=' + (currentTabIndex + 1) + ']').focus();
                                $('[tabindex="' + (currentTabIndex + 1) + '"]').click();
                            }
                        }, 200);
                    }
                }
                return false;
            }
        });
        $(options.input).on("keyup", function (e) {
            if (e.keyCode != 9 && e.keyCode != 13) {
                $(options.hidden).val('');
                if (e.keyCode == 38) {
                    e.stopPropagation();
                    e.preventDefault();
                    _clearHiddenHelper();
                    _changleSelectedResultItem(true, false);
                    return false;
                }
                if (e.keyCode == 40) {
                    e.stopPropagation();
                    e.preventDefault();
                    _clearHiddenHelper();
                    _changleSelectedResultItem(false, false);
                    return false;
                }
                typeCache.push($(options.input).val());
                typeCacheList.push($(options.input).val());
                if (timerAutoComplete != null) {
                    clearTimeout(timerAutoComplete);
                }
                timerAutoComplete = setTimeout(function () {
                    if (typeCache.length > 0) {
                        _callAjaxGetSource(typeCache.pop());
                        typeCache = [];
                    }
                }, 180);

            }
        });
        $(options.input).on("focusout blur", function () {
            _setValueOnMainInput();
        });

        $(options.input).on("click", function () {
            if ($(this).val().length == 0) {
                getCookie(options.CultureCokkieName) == '' || getCookie(options.CultureCokkieName) == options.defaultCulture ? _callAjaxGetSource(options.firstEmptyDataForLoadAjax) : _callAjaxGetSource(options.secondEmptyDataForLoadAjax);
            }
            else if (/[^\u0600-\u06FF]/g.test($(this).val().substring(0, 5).replace(/[-, ,),(,,]/g, ''))) {
                _callAjaxGetSource(options.secondEmptyDataForLoadAjax);
            } else { //if writtent text is Persian
                _callAjaxGetSource(options.firstEmptyDataForLoadAjax);
            }
            $(options.input).select();
        });
        $(document).click(function () {
            _closePopup();
        });
        $("." + options.selector.result).click(function (event) {
            event.stopPropagation();
        });
    };

    var _clearHiddenHelper = function () {
        var parent = $(_getInputParentElement());
        parent.data("x-text", "");
        parent.data("x-val", "");
    };


    var _setValueOnHiddenHelper = function (item) {
        if (item != null) {
            var comma = (item.IsPersian ? "، " : ", ");
            var text = item.Text + (_notEmpty(item.ShortDescription) ? comma + item.ShortDescription : "");
            var value = item.Value;

            var parent = $(_getInputParentElement());
            parent.data("x-text", text);
            parent.data("x-val", value);
            if (!$(options.input).is(":focus")) {
                _setValueOnMainInput();
            }
        }
    };

    var _callAjaxGetSource = function (part) {
        if (part.length >= options.minLength) {
            if (options.loadingAnimation) {
                $(options.input).closest("." + options.selector.container).addClass("loading");
            }
            var sendPart = part;

            _clearHiddenHelper();

            $.ajax({
                url: options.sourceUrl,
                //async: true,
                type: 'POST',
                dataType: 'json',
                data: {
                    Part: sendPart
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    $(options.input).closest("." + options.selector.container).removeClass("loading");
                },
                timeout: 10000
            }).done(function (res) {
                if (sendPart == $(options.input).val() || sendPart == options.firstEmptyDataForLoadAjax || sendPart == options.secondEmptyDataForLoadAjax) {
                    options.data = res;
                    //=====================
                    var item = _getExactItem(res); //res.length > 0 ? res[0] : null;
                    _setValueOnHiddenHelper(item);
                    //=====================
                    generatePopup();
                }
                if (options.loadingAnimation) {
                    $(options.input).closest("." + options.selector.container).removeClass("loading");
                }
            });
        } else {
            if ($(options.input).val().length == 0) {
                getCookie('_cultureSetting') == options.defaultCulture ? _callAjaxGetSource(options.firstEmptyDataForLoadAjax) : _callAjaxGetSource(options.secondEmptyDataForLoadAjax);
            }
        }

    };

    var _notEmpty = function (obj) {
        var flag = ((typeof obj === "undefined") || (obj === null) || (obj === "") || (obj.length == 0)) ? false : true;
        return flag;
    }
    var _getIndex = function (res, index) {
        return (res.length > index) ? res[index] : null;
    }
    var _getExactItem = function (res) {
        var text = $(options.input).val();
        var first = _getIndex(res, 0);
        var second = _getIndex(res, 1);
        if (_notEmpty(text) && res.length > 0) {
            var item = res.filter(q => q.Text === text)[0];
            item = _notEmpty(item) ? item : first;
            item = _notEmpty(item) ?
                (_notEmpty(item.Value) && item.Value.toLowerCase() === 'cat' ? second : item) :
                null;
            return item;
        }

        else {
            return null;
        }
    }
    var _setValueOnMainInput = function () {
        var parent = $(_getInputParentElement());
        var text = parent.data("x-text");
        var val = parent.data("x-val");
     
        if (val != "") {
            _setValue(text, val);
        }
    }
    var _addCancelButtonElement = function () {
        //Generate Cancel Button
        if ($(_getInputParentElement()).find("." + options.selector.cancelButton).length) {
            $(_getInputParentElement()).find("." + options.selector.cancelButton).remove();
        }
        if ($(_getInputParentElement()).find("." + options.selector.loadingButton).length) {
            $(_getInputParentElement()).find("." + options.selector.loadingButton).remove();
        }
        if (options.cancelButton == true) {
            $("<span/>", {
                class: options.selector.cancelButton,
                html: $('<i/>', {
                    class: 'icon icon-group-358 icon-close'
                }),
                mousedown: function (e) {
                    $(options.input).val('');
                    $(options.hidden).val('');
                    setTimeout(function () { $(options.input).trigger("click"); }, 200);
                }
            }).insertBefore(options.input);
            $("<span/>", {
                class: options.selector.loadingButton,
                html: $('<i/>', {
                    class: 'icon icon-group-322 icon-spining'
                })
            }).insertBefore(options.input);
            return true;
        }
        return false;
    };
    var _setVisibleCancelButtonElement = function () {
        if ($(options.input).val().length) {
            $(options.input).closest("." + options.selector.container).addClass("cancel");
        } else {
            $(options.input).closest("." + options.selector.container).removeClass("cancel");
        }
    };
    var _changleSelectedResultItem = function (goUp, firstLoad) {
        var getSelectedRowIndex = 0;
        if ($(_getInputParentElement()).find("." + options.selector.result).find("." + options.selector.itemSelectedCls).length) {
            $(_getInputParentElement()).find("." + options.selector.result).find("." + options.selector.itemOption + ":not(." + options.selector.disableItem + ")").each(function (i, e) {
                if ($(e).hasClass(options.selector.itemSelectedCls)) {
                    getSelectedRowIndex = i;
                }
            });
        }
        $(_getInputParentElement()).find("." + options.selector.result).find("." + options.selector.itemSelectedCls).removeClass(options.selector.itemSelectedCls);
        if (!firstLoad) {
            if (goUp) {
                getSelectedRowIndex--;
            } else if (!goUp) {
                getSelectedRowIndex++;
            }
            if (getSelectedRowIndex < 0) {
                getSelectedRowIndex = $(_getInputParentElement()).find("." + options.selector.result).find("." + options.selector.itemOption + ":not(." + options.selector.disableItem + ")").length - 1;
            }
            if (getSelectedRowIndex > $(_getInputParentElement()).find("." + options.selector.result).find("." + options.selector.itemOption + ":not(." + options.selector.disableItem + ")").length - 1) {
                getSelectedRowIndex = 0;
            }
        }

        if ($(_getInputParentElement()).find("." + options.selector.result).find("." + options.selector.itemOption + ":not(." + options.selector.disableItem + ")").length) {
            $(_getInputParentElement()).find("." + options.selector.result).find("." + options.selector.itemOption + ":not(." + options.selector.disableItem + ")").each(function (i, e) {
                if (getSelectedRowIndex == i) {
                    $(e).addClass(options.selector.itemSelectedCls);
                    $($(_getInputParentElement()).find("." + options.selector.result)).animate({
                        scrollTop: $(e).position().top - 35
                    }, 50);
                }
            });
        }
    };
    var _setUserOptions = function (userOptions) {
        if (typeof userOptions.minLength !== "undefined" && userOptions.minLength != '') {
            options.minLength = userOptions.minLength;
        }
        if (typeof userOptions.maxItem !== "undefined" && userOptions.maxItem != '') {
            options.maxItem = userOptions.maxItem;
        }
        if (typeof userOptions.delay !== "undefined" && userOptions.delay != '') {
            options.delay = userOptions.delay;
        }
        if (typeof userOptions.display !== "undefined" && userOptions.display != '') {
            options.display = userOptions.display;
        }
        if (typeof userOptions.cancelButton !== "undefined" && userOptions.cancelButton != '') {
            options.cancelButton = userOptions.cancelButton;
        }
        if (typeof userOptions.loadingAnimation !== "undefined" && userOptions.loadingAnimation != '') {
            options.loadingAnimation = userOptions.loadingAnimation;
        }
        if (typeof userOptions.value !== "undefined" && userOptions.value != '') {
            options.value = userOptions.value;
        }
        if (typeof userOptions.sourceUrl !== "undefined" && userOptions.sourceUrl != '') {
            options.sourceUrl = userOptions.sourceUrl;
        }
        options.hidden = _getInputHiddenElement;
    };
    var _getInputParentElement = function () {
        //Get Input Parent Element
        return $(options.input).closest("div");
    };
    var _getInputHiddenElement = function () {
        //Get Input Hidden Element
        return $(options.input).closest("div").find("input[type='hidden']");
    };
    var _closePopup = function () {
        options.data = [];
        generatePopup();
        $(_getInputParentElement()).find("." + options.selector.result).hide();
    };
    var _clickNextAutoComplete = function () {
        _closePopup();
        var currentTabIndex = parseInt($(options.input).attr("tabindex"));
        setTimeout(function () {
            if (currentTabIndex != null && currentTabIndex > 0 && $('[tabindex="' + (currentTabIndex + 1) + '"]') != undefined) {
                if ($('[tabindex="' + (currentTabIndex + 1) + '"][data-ac]').length) {
                    $('[tabindex=' + (currentTabIndex + 1) + ']').focus();
                    $('[tabindex="' + (currentTabIndex + 1) + '"]').click();
                }
            }
        }, 100);
    };
    var _setValue = function (text, value) {
        options.value = value;
        $(options.input).val(text);
        $(options.hidden).val(value);
    };
    var _replaceSearchText = function (text) {
        if (text == '' || text == null || $(options.input).val().length == 0)
            return text;
        var tag = 'b' || 'strong'
            , words = [$(options.input).val()] || []
            , regex = RegExp(words.join('|'), 'gi') // case insensitive
            , replacement = '<' + tag + '>$&</' + tag + '>';

        return text.replace(regex, replacement);
    };
    var generatePopup = function () {
        _setVisibleCancelButtonElement();
        _setCultureClass();
        var currentData = options.data;
        $(_getInputParentElement()).find("." + options.selector.result).hide();
        if ($(_getInputParentElement()).find("." + options.selector.result).length == 0) {
            $("<div/>", {
                class: options.selector.result,
                html: ''
            }).insertAfter(options.input);
        }
        $(_getInputParentElement()).find("." + options.selector.result).html('');
        if (currentData != null && currentData.length > 0) {
            if (options.display == true) {
                $(_getInputParentElement()).find("." + options.selector.result).show();
            }
            var curUl = $("<ul/>", {
                class: options.selector.list,
            });
            $(currentData).each(function (itemIndex, itemVal) {
                if (itemVal.PItem == null || itemVal.PItem.length == 0) {
                    var ulContent = _getPopupUlItem(itemVal);
                    var subList = $("<ul/>", {
                        class: options.selector.list,
                    });
                    var subCount = 0;
                    $(currentData).each(function (subItemIndex, subItemVal) {
                        if (subItemVal.PItem == itemVal.ID) {
                            subCount++;
                            subList.append(_getPopupUlItem(subItemVal));
                        }
                    });
                    if (subCount > 0) {
                        ulContent.append(subList);
                    }
                    curUl.append(ulContent);
                }
            });
            $(_getInputParentElement()).find("." + options.selector.result).html(curUl);
            _changleSelectedResultItem(true, true);
        }
    };
    var _getPopupUlItem = function (itemVal) {
        var itemOption = $("<div/>", {
            class: options.selector.itemOption
        }).append($('<i/>', {
            class: 'icon icon-path-68-1' //itemVal.Icon
        })).append($('<div/>', {
            class: options.selector.itemOptionText,
            html: $("<div/>", {
                html: $("<span/>", {
                    html: _replaceSearchText(itemVal.Text)
                })
            }).append($("<small/>", {
                class: options.selector.itemOptionShortDesc + (itemVal.ShortDescription != null && itemVal.ShortDescription.length > 0 ? "" : " hidden"),
                html: _replaceSearchText(itemVal.ShortDescription)
            })).append((itemVal.Tag == null || itemVal.Tag.length == 0 ? '' : $("<span/>", {
                class: options.selector.tagItem,
                html: _replaceSearchText(itemVal.Tag)
            })))
        }).append($("<small/>", {
            class: options.selector.itemOptionLongDesc,
            html: $("<span/>", {
                html: _replaceSearchText(itemVal.LongDescription)
            })
        })));
        if (itemVal.PItem == null || itemVal.PItem == '') {
            itemOption.addClass(options.selector.itemMainOption);
        }
        if (itemVal.IsSelectable != true) {
            itemOption.addClass(options.selector.disableItem);
        }
        var curItem = $("<li/>", {
            class: options.selector.item,
            html: itemOption,
            mousedown: function (e) {
                // Don't blur the input
                _clearHiddenHelper();

                _setValue($(this).attr("data-text"), $(this).attr("data-val"));
                _clickNextAutoComplete();
            },
        });
        var appendText = "";
        if (options.sourceUrl == "/LoadAndFill/HotelCities") {
            if (itemVal.LongDescription != '' && itemVal.LongDescription != null && itemVal.LongDescription.length > 0) {
                appendText += ", " + itemVal.LongDescription;
            }
        }
        curItem.attr("data-text", itemVal.Text + (itemVal.ShortDescription != null && itemVal.ShortDescription.length ? ", " + itemVal.ShortDescription : "") + appendText);
        curItem.attr("data-val", itemVal.Value);
        if (itemVal.IsSelectable != true) {
            curItem.addClass(options.selector.disableItem);
        }
        return curItem;
    };
    _create(userOptions);
    generatePopup();
};
